/* RESPONSIBLE TEAM: team-inbox-management */
import type AppService from 'embercom/services/app-service';
import BaseSettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import type Store from '@ember-data/store';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';
import type Transition from '@ember/routing/transition';
import getTransitionParams from 'embercom/lib/router/get-transition-params';
import type Session from 'embercom/services/session';
import type TicketStateService from 'embercom/services/ticket-state-service';

type ModelParams = {
  ticket_type_id: string;
};

export default class extends BaseSettingsRoute {
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare permissionsService: $TSFixMe;
  @service declare ticketStateService: TicketStateService;
  @service declare session: Session;

  get securityAppSettings() {
    return this.store.findRecord('security-app-settings', this.app.id).catch(function () {
      return {};
    });
  }

  get app() {
    return this.appService.app;
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    let permission = 'can_access_product_settings';
    this.permissionsService.ensurePermissionWhenTransitioning(permission, transition);
    // Make sure session is setup before fetching workspace dependant data
    let routeParams = getTransitionParams(transition) as {
      'apps.app': { app_id: string };
    };
    let workspaceId = routeParams['apps.app'].app_id;

    this.session.switchWorkspace(workspaceId);

    await this.session.workspace.fetchRequiredAttributes();
  }

  async model(params: ModelParams) {
    await this.ticketStateService.setup();

    return hash({
      ticketType: this.store.findRecord('inbox/ticket-type', params.ticket_type_id),
      ticketTypes: this.store.findAll('inbox/ticket-type').toArray(),
      securitySettings: this.securityAppSettings,
      convertInboundEmailsToTicketsSettings: this.store.findRecord(
        'email-convert-inbound-emails-to-tickets-settings',
        this.app.id,
      ),
    });
  }
}
